// Import dependencies
import React from 'react';

// Import styling
import './Terms.css'


class TermsPage extends React.Component {
    render() {
        return(
            <div id='termsCard' className='container card'>
                <h3>Terms and Conditions</h3>

                <p>The recordings and live feed video streamed on this website are the property and copyright of the 
                Osher Lifelong Learning Institute (OLLI) at University of California Irvine (UCI).  The user of this 
                website may view or download a single copy of the videos (or live feed) for educational purposes only 
                to be viewed by current OLLI at UCI members.  You may not copy, distribute in any way, embed or post the 
                content on this website without the express permission of OLLI at UCI.</p>
            </div>
        );
    }
}

export default TermsPage;